<div class="d-flex align-items-center">
  <button nbButton ghost size="tiny" (click)="toggleSidebar()" nbTooltip="Toggle Sidebar" i18n-nbTooltip>
    <nb-icon class="menu-icon" [icon]="compact ? 'menu-outline' : 'menu-arrow-outline'"></nb-icon>
  </button>
  <img class="logo ml-3" (click)="navigateHome()" src="assets/img/logo.png" />
  <div class="flex-grow-1 ml-3">
    <a class="app-name" (click)="navigateHome()">{{ title }}</a>
  </div>
  <nb-user
    class="user-menu ml-3"
    [nbContextMenu]="userMenu"
    nbContextMenuTrigger="hover"
    shape="round"
    name="{{ username }}"
    color="#f7f9fc"
  >
  </nb-user>
</div>
